import { gql, useLazyQuery, useQuery } from '@apollo/client';
export const SERVIBLE_OBJECT_VIEW_READ_BY_RELATED = gql`
  query servibleObjectViewReadByRelated($relatedId: Long, $relatedObjectTypeId: Int) {
    servibleObjectView_readByRelated(relatedId: $relatedId, relatedObjectTypeId: $relatedObjectTypeId) {
      elementId
      elementTypeId
      elementTypeName
      elementName
    }
  }
`;
export const useServibleObjectViewByRelatedLazyQuery = options => {
  return useLazyQuery(SERVIBLE_OBJECT_VIEW_READ_BY_RELATED, options);
};
export const useServibleObjectViewByRelatedQuery = options => {
  return useQuery(SERVIBLE_OBJECT_VIEW_READ_BY_RELATED, options);
};